.dynamic-entry {
  @apply p-5 mx-auto rounded-lg box-border min-h-260;

  background-color: var(--clrs-bg-dynamic-entry);
  font-family: var(--typography-base-dynamic-entry);
  color: var(--clrs-text-dynamic-entry);
}
